import { colors } from '../theme';
import { themeColors } from '../themes';
import { allowedStatuses } from '../allowedStatuses';

export const statuses = {
  inProcess: { id: 0, color: colors.blueLight, title: 'inProcess' },
  ordered: { id: 1, color: colors.blueDark, title: 'ordered' },
  shipped: { id: 2, color: colors.blueMed, title: 'shipped' },
  completed: { id: 3, color: colors.greenBright, title: 'completed' },
  notPaid: { id: 4, color: colors.red, title: 'notPaid' },
  failed: { id: 5, color: colors.orange, title: 'failed' },
  canceled: { id: 6, color: colors.greyLight, title: 'canceled' },
  returned: { id: 7, color: colors.beige, title: 'returned' },
  refunded: { id: 8, color: colors.greenLight, title: 'refunded' },
  stopped: { id: 9, color: colors.pinkDark, title: 'stopped' },
  exported: { id: 10, color: colors.yellow, title: 'exported' },
  pendingCancellation: { id: 11, color: colors.greyMid, title: 'pendingCancellation' },
  pendingReturn: { id: 12, color: themeColors.brightPurple, title: 'pendingReturn' },
  returnInProcess: { id: 13, color: themeColors.mustard, title: 'returnInProcess' },
  new: { id: 14, color: themeColors.turquoise, title: 'new' },
  undeliverable: { id: 15, color: themeColors.blueDark, title: 'undeliverable' },
  delivered: { id: 3, color: colors.greenBright, title: 'delivered' },
};

export const statusList = Object.keys(statuses).map(s => ({
  status: s,
  ...statuses[s],
}));

export const getAllowedStatuses = currentStatus => {
  return [
    {
      status: currentStatus,
      ...statuses[currentStatus],
    },
    ...(allowedStatuses[currentStatus] ?? []).map(s => ({
      status: s,
      ...statuses[s],
    })),
  ];
};

export const STATUS_TITLES = Object.entries(statuses).reduce(
  (acc, [key, { title }]) => ({ ...acc, [key]: title }),
  {},
);
